import { WorkspaceLiveNotificationTypesRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/settings/live-notification-types')({
  component: WorkspaceLiveNotificationTypesRoute,
});
